export const FEATURE_FLAGS = {
  clientTaxDocuments: 'clientTaxDocuments',
  D2: 'D2',
  d2InPersonSigning: 'd2InPersonSigning',
  manualIma: 'manualIma',
  nbinStraightThroughEnabledOverride: 'nbinStraightThroughEnabledOverride',
  nSeriesAgreement: 'nSeriesAgreement',
  scheduleA: 'scheduleA',
  taxProfile: 'taxProfile',
  rnaAuthCancelForm: 'rnaAuthCancelForm',
  rtqNoteAssessment: 'rtqNoteAssessment',
  feesAccess: 'feesAccess',
} as const;

export type FeatureFlag = keyof typeof FEATURE_FLAGS;

export type FeatureFlagResponse = {
  featureEnabled: boolean;
};
